<div class="container">
  <h1>In The News</h1>
  <div fxLayout="row wrap" fxLayoutAlign="start start" fxLayoutGap.gt-sm="20px">
    <queblo-article-card fxFlex="" *ngFor="let article of news" [article]="article"></queblo-article-card>
  </div>
</div>
